import { render, staticRenderFns } from "./HomeAYB.vue?vue&type=template&id=2640d82b&scoped=true"
import script from "./HomeAYB.vue?vue&type=script&lang=js"
export * from "./HomeAYB.vue?vue&type=script&lang=js"
import style0 from "./HomeAYB.vue?vue&type=style&index=0&id=2640d82b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640d82b",
  null
  
)

export default component.exports